import { Config } from '../Config';
import { JobCenterModelInterface } from '../Model/JobCenterModelInterface';
import { RouteConstants } from '../RouteConstants';
import { StaticSettings } from '../StaticSettings';
import { Type, typeFromModel } from '../Type';

export class UriBuilder {
    private config: Config;

    constructor(config?: Config) {
        this.config = config || Config.fromEnv();
    }

    public uriForModel(model: JobCenterModelInterface): string {
        return RouteConstants.routeForType(typeFromModel(model)) + '/' + model.referenceId;
    }

    public sharingUriForModel(model: JobCenterModelInterface): string {
        return this.config.baseUrl + this.uriForModel(model);
    }

    public formUriForType(type: Type): string {
        const config = this.config;
        const uriSettings = StaticSettings.uri;

        const formUri = type === Type.Candidate ? config.candidateFormUri : config.jobVacancyFormUri;

        const formAnchor = type === Type.Candidate ? uriSettings.candidateFormAnchor : uriSettings.jobVacancyFormAnchor;
        if (formAnchor === undefined) {
            return formUri;
        }

        if (formUri.substr(-1) !== '#' && formAnchor?.substr(0, 1) !== '#') {
            return formUri + '#' + formAnchor;
        } else {
            return formUri + formAnchor;
        }
    }

    public paginationUriForType(type: Type, pageNumber: number): string {
        return this.config.basePath + RouteConstants.routeForType(type) + '/page/' + pageNumber;
    }
}
